function cleanupProductUrlBeforeApiPush(url) {
    let updatedUrl = url;
    updatedUrl = updatedUrl.replaceAll("-", " ");
    updatedUrl = updatedUrl.trim();
    updatedUrl = updatedUrl.replaceAll(" ", "-");
    updatedUrl = updatedUrl.replaceAll("/", "-");
    updatedUrl = updatedUrl.replaceAll("--", "-");
    updatedUrl = updatedUrl.toLowerCase();
    return updatedUrl;
}

export default cleanupProductUrlBeforeApiPush;
